// What the cabinets know of each product (docs/tasks/35, Products): its training
// status on every cabinet type, the shelves and weight trays it is placed on.
// Built from the endpoints that exist: per type, per cabinet.

async function settle(p) {
  try { return await p; } catch { return null; }
}

// The pose scripts of the capture app (ios/AinaopenCapture/Config/AppConfig.swift):
// three shots since 29 Sep; products shot before keep their six-shot labels.
export const POSES = {
  boxed_bagged: [["front", "Front"], ["back", "Back"], ["corner_fl", "Front-left corner (45°)"]],
  cylindrical: [["front", "Front (level)"], ["side_a", "Rotated 1/3"], ["side_b", "Rotated 2/3"]],
  bagged: [["front", "Front"], ["back", "Back"], ["front_tilt", "Front, tilted"]],
};
export const LEGACY_POSES = {
  corner_fr: "Front-right corner", corner_bl: "Back-left corner", corner_br: "Back-right corner", left: "Left side",
  right: "Right side", top: "Top angle", vending: "Vending angle", top_1: "Top angle", top_2: "Top angle, rotated",
  bottom: "Bottom", diag_fl: "Diagonal front-left", diag_fr: "Diagonal front-right", tilt_back: "Tilted back",
};
export const SHAPES = { boxed_bagged: "boxed or bagged", cylindrical: "bottle, can or bowl", bagged: "soft pack or bag" };
export const SIZE_CLASSES = {
  flat_small: ["small and flat (bar, sachet)", [90, 30, 12]],
  can_small: ["can or small bottle", [115, 66, 66]],
  medium: ["medium (carton, 0.5 l bottle, box)", [200, 70, 50]],
  large: ["large (multipack, big box)", [300, 120, 80]],
};
export const STATUS_TONE = {
  trained: "bg-emerald-100 text-emerald-800", partial: "bg-amber-100 text-amber-800", untrained: "bg-rose-100 text-rose-800",
};

// onPartial receives the context once the training is in (placements still empty),
// so a page can show it before every cabinet's layout has answered.
export async function loadCatalogueContext(api, onPartial) {
  const [types, devicesRaw] = await Promise.all([settle(api.listCabinetTypes()), settle(api.listDevices())]);
  const devices = (Array.isArray(devicesRaw) ? devicesRaw : devicesRaw?.data || []).filter((d) => !d.revoked && d.hardware !== "emulator");
  const statusByType = {};
  await Promise.all((types || []).map(async (t) => {
    const st = await settle(api.getCabinetTypeTrainingStatus(t.id));
    statusByType[t.id] = Object.fromEntries((st?.products || []).map((p) => [p.product_uuid, p]));
  }));
  const placements = {};
  const trays = {};
  onPartial?.({ types: types || [], statusByType, placements: {}, trays: {}, devices, partial: true });
  await Promise.all(devices.map(async (d) => {
    const [pl, w] = await Promise.all([settle(api.getDevicePlanogram(d.id)), d.weight ? settle(api.getDeviceWeight(d.id)) : null]);
    (pl?.shelves || []).forEach((slots, i) => slots.forEach((s) => {
      (placements[s.product_uuid] = placements[s.product_uuid] || []).push({ deviceId: d.id, name: d.name || d.id, shelf: i + 1 });
    }));
    for (const t of w?.planogram?.trays || []) {
      const pid = t.product?.product_uuid;
      if (pid) (trays[pid] = trays[pid] || []).push({ deviceId: d.id, name: d.name || d.id, tray: t.id, unit_g: t.product?.unit_g });
    }
  }));
  return { types: types || [], statusByType, placements, trays, devices };
}
